import { Navigate } from "react-router-dom";
import { useUser } from "../../store/auth/AuthSelectors";
import { RoleBasedAccessProps } from "./Guard.types";

export function RoleBasedAccess({children, allowedRoles, navigateTo}: RoleBasedAccessProps) {
    const user = useUser();
    const fallBack = typeof navigateTo === "string" ? <Navigate to={navigateTo} /> : null;
    return !user ? fallBack : !allowedRoles?.length ? <>{children}</> :  allowedRoles?.includes(user.role) ? <>{children}</> : fallBack;
}